
import React from "react";

import './App.css';
import Navbar from "./components/navbar";
import Home from "./components/home.jsx";
import Footer from "./components/footer";

function App() {
  return (
    <div>

     <Navbar/>
    <Home/>
 
    <Footer/>
    </div>
  );
}

export default App;
